import React from 'react';
import Spinner from '../UI/Spinner/spinner';
import bdApi from '../../Api/BankDataApi';
import * as constants from '../../Actions/types';
import css from './bfm.css';

class FastlinkCallBack extends React.Component {
  state = { callBackCompleted: false };

  componentDidMount() {
    const { location } = this.props;
    

    if (location.search) {
      bdApi
        .get(
          `${constants.ROOT_URL}/bankfeed/${localStorage.getItem(
            'bookid'
          )}/yodlee/callback${location.search}`
        )
        .then(() => {
          setTimeout(() => {
            this.setState({ callBackCompleted: true });
            window.parent.postMessage('closeyodlee', '*');
          }, 500);
        });
    } else {
      setTimeout(() => {
        this.setState({ callBackCompleted: true });
        window.parent.postMessage('closeyodlee', '*');
      }, 500);
    }
  }

  render() {
    if (!this.state.callBackCompleted) return (
      <div className={css.note}>
        <Spinner small />
        <div className={css.muted}>Processing please wait...</div>
      </div>);
    return <div>Completed</div>;
  }
}

export default FastlinkCallBack;



// WEBPACK FOOTER //
// ./src/components/FeedManagment/FastLinkCallBack.js